export const HOME_SET_CURRENT_USER = 'HOME_SET_CURRENT_USER';
